import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { collection, getDocs } from "firebase/firestore";
import { CustomAdsData } from "../../interface/customads.interface";
import { db } from "../../lib/firebase";
import MainButton from "../../components/Button";
import AddCustomAds from "./components/addAds";
import AdsCard from "./components/adsCard";
import SkeletonCard from "../../components/skeltonCard";
export default function CustomAds() {
  const [filter, setFilter] = useState<string>("all");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [ads, setAds] = useState<CustomAdsData[]>([]);
  const [openAddCustomAdsModal, setopenAddCustomAdsModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        setLoading(true);
        const adsCollection = collection(db, "bannerAdd");
        const adsnapshot = await getDocs(adsCollection);
        const adsList = adsnapshot.docs.map((doc) => ({
          id: doc.id,
          ...(doc.data() as Omit<CustomAdsData, "id">),
        }));

        setAds(adsList);
      } catch (error) {
        console.error("Error fetching ads: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, []);
  const handlePublishStatusUpdate = (updatedAd: CustomAdsData) => {
    setAds((prevAds) =>
      prevAds.map((ad) => (ad.id === updatedAd.id ? updatedAd : ad))
    );
  };
  const filteredads = ads.filter((ads: CustomAdsData) => {
    const eventName = ads.sponsorname || "";
    const matchesSearch = eventName
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesFilter =
      filter === "all" ||
      (filter === "publish" && ads.publish) ||
      (filter === "unpublish" && !ads.publish);
    return matchesSearch && matchesFilter;
  });
  const handleOpenModal = () => setopenAddCustomAdsModal(true);
  const handleCloseModal = () => setopenAddCustomAdsModal(false);
  return (
    <div>
      {openAddCustomAdsModal && (
        <AddCustomAds open={openAddCustomAdsModal} onClose={handleCloseModal} />
      )}
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-center mb-8 space-y-4 sm:space-y-0">
        <div className="flex items-center w-full sm:w-auto">
          <div className="relative flex-1 sm:flex-none">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Search by name"
              // className="pl-10 pr-4 py-2 w-full sm:w-64 bg-background border-gray-700 rounded-full focus:ring-2 focus:ring-primary transition-all"
              className="w-full pl-9 pr-2 focus-visible:outline-none h-[50px] bg-bgCard border rounded-full"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
        {/* Dropdown and Add Button */}

        <div className="flex items-center space-x-4">
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="bg-bgCard border-bg rounded-full py-2 px-2 focus:ring-2 focus:ring-primary"
          >
            <option value="all">All</option>
            <option value="publish">Published</option>
            <option value="unpublish">Unpublished</option>
          </select>
          <MainButton
            onClick={handleOpenModal}
            className="rounded-full"
            label="Add Ads"
          ></MainButton>
        </div>
      </div>

      {/* ads List */}
      {loading ? (
        // Show skeletons during loading
        <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
          {Array.from({ length: 8 }).map((_, index) => (
            <SkeletonCard key={index} />
          ))}
        </div>
      ) : filteredads.length > 0 ? (
        <div className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8">
          {filteredads.map((ads, index) => (
            <AdsCard
              item={ads}
              key={index}
              onPublishStatusChange={handlePublishStatusUpdate}
            />
          ))}
        </div>
      ) : (
        <p className="text-gray-500 flex justify-center">No events found.</p>
      )}
    </div>
  );
}
